import request from '../../../api/request';
import {
  CreateOtherStudyData,
  EducationalInformation,
  OtherStudies,
  OtherStudiesFormData,
} from '../parts/educationalInformation/types';

const EDUCATIONAL_INFORMATION = {
  GET_POSTULANT_EDUCATIONAL_INFORMATION: (studentId: string | number) =>
    `maintainers-portal/student-management/educational-information/${studentId}`,
  GET_OTHER_STUDIES_FORM_DATA: () =>
    `maintainers-portal/student-management/educational-information/form-data`,
  GET_OTHER_STUDIES: (studentId: string | number) =>
    `maintainers-portal/student-management/educational-information/other-studies/${studentId}`,
  CREATE_OTHER_STUDY: () =>
    `maintainers-portal/student-management/educational-information/student-external-studies`,
  UPDATE_OTHER_STUDY: (id: string | number) =>
    `maintainers-portal/student-management/educational-information/student-external-studies/${id}`,
  DELETE_OTHER_STUDY: (id: string | number) =>
    `maintainers-portal/student-management/educational-information/student-external-studies/${id}`,
};

export const getPostulantEducationalInformation = (studentId: string | number) => {
  return request<EducationalInformation>(
    EDUCATIONAL_INFORMATION.GET_POSTULANT_EDUCATIONAL_INFORMATION(studentId),
  );
};

export const getOtherStudiesFormData = () => {
  return request<OtherStudiesFormData>(
    EDUCATIONAL_INFORMATION.GET_OTHER_STUDIES_FORM_DATA(),
  );
};

export const getOtherStudies = (
  studentId: string | number,
  items: number = 10,
  page: number = 0,
) => {
  return request<OtherStudies>(
    EDUCATIONAL_INFORMATION.GET_OTHER_STUDIES(studentId),
    {
      method: 'get',
      params: {
        items_per_page: items,
        page,
      },
    },
  );
};

export const updateOtherStudy = (id: number, data: CreateOtherStudyData) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (value instanceof File) formData.append(key, value, value.name);
    else if (key === 'validated') formData.append(key, value);
    else if (value) {
      formData.append(key, value);
    }
  });

  return request(EDUCATIONAL_INFORMATION.UPDATE_OTHER_STUDY(id), {
    method: 'put',
    data: formData,
  });
};

export const deleteOtherStudy = (id: number) => {
  return request(EDUCATIONAL_INFORMATION.DELETE_OTHER_STUDY(id), {
    method: 'delete',
  });
};

export const createOtherStudyWithFiles = (data: CreateOtherStudyData) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (value instanceof File) formData.append(key, value, value.name);
    else if (key === 'validated') formData.append(key, value);
    else if (value) {
      formData.append(key, value);
    }
  });

  return request(EDUCATIONAL_INFORMATION.CREATE_OTHER_STUDY(), {
    method: 'post',
    data: formData,
  });
};
